import { serialize } from 'object-to-formdata'
import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getChargeSettings() {
    return axiosIns.get('/waiter/charge_settings')
  },
  createChargeSetting({
    name, rate, customerCount, taxCharge, roundingMethod, roundingDigit, roundingMultiple,
  }) {
    const formData = serialize(snakecaseKeys({
      chargeSetting: {
        name, rate, customerCount, taxCharge, roundingMethod, roundingDigit, roundingMultiple,
      },
    }))

    return axiosIns.post('/waiter/charge_settings', formData)
  },
  updateChargeSetting({
    id, name, rate, customerCount, taxCharge, roundingMethod, roundingDigit, roundingMultiple,
  }) {
    const formData = serialize(snakecaseKeys({
      chargeSetting: {
        name, rate, customerCount, taxCharge, roundingMethod, roundingDigit, roundingMultiple,
      },
    }))

    return axiosIns.put(`/waiter/charge_settings/${id}`, formData)
  },
  deleteChargeSetting(id) {
    return axiosIns.delete(`/waiter/charge_settings/${id}`)
  },
}
